<div class="clearfix">
    <div class="col-12 md:col-12"><h3>{{'Mg_Admin_Deleg' | translate}}</h3></div>
    <div class="col-12 md:col-12">
        <p-tabView
                [controlClose]="true"
                (onChange)="handleChange($event)"
                (onClose)="closeTab($event)"
                [activeIndex]="index"
        >
            <p-tabPanel [header]="'List' | translate" [selected]="0 == index" [headerStyle]="{ 'font-weight': 'bold' }">
                <div class="table-tools">
                    <button
                            (click)="add($event)"
                            class="p-button p-component p-button-text-only btn-square"
                    >
                        {{'Add_User' | translate}}
                    </button>
                </div>
                <br class="col-12 md:col-12" />
                <p-table
                    #dt
                    [selectionMode]="'single'"
                    [columns]="listColumns"
                    [value]="results"
                    [rows]="100"
                    [paginator]="true"
                    responsiveLayout="stack"
                    [breakpoint]="'960px'"
                    (onRowSelect)="showDetails($event)"
                    (onFilter)="setFilteredList($event)"
                    [sortField]="'name'"
                >
                    <ng-template pTemplate="caption">
            <span class="header-grid-wrapper">
              <span class="align-right">{{'Tot' | translate}} {{ results.length }} {{'Cf_Users_1' | translate}}</span>
            </span>
                    </ng-template>
                    <ng-template let-columns pTemplate="header">
                        <tr>
                            <th [pSortableColumn]="columns[0].field" class="width-auto">
                                <p-sortIcon [field]="columns[0].field"></p-sortIcon>{{ columns[0].header }}
                                <input
                                        (click)="$event.stopPropagation()"
                                        pInputText
                                        type="text"
                                        (input)="dt.filter($event.target.value, columns[0].field, 'contains')"
                                        style="color: darkgrey"
                                />
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template let-rowData let-columns="columns" pTemplate="body">
                        <tr [pSelectableRow]="rowData">
                            <td class="width-auto">
                                {{ rowData[columns[0].field] }}
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7">{{'Empty' | translate}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>
            @for (item of itemsSelected; track item; let i = $index) {
                <p-tabPanel
                        header="{{ item._label }}"
                        [selected]="i == index - 1"
                        [closable]="true"
                >
                    @if (item.id === -1) {
                        <app-add-admindelegate
                                [delegateList]="delegateList"
                                [delegateBase]="delegateBase"
                                (onCancel)="cancelAdd($event)"
                                (onValidate)="addTab($event)"
                        >
                        </app-add-admindelegate>
                    }
                    @if (item.id !== -1) {
                        <app-edit-admindelegate
                                [delegateList]="delegateList"
                                [delegateBase]="delegateBase"
                                [item]="item"
                                (onCancel)="closeTab($event)"
                                (onValidate)="validateTab($event)"
                                (onDeleteItem)="confirmDelete($event)"
                        >
                        </app-edit-admindelegate>
                    }
                </p-tabPanel>
            }
        </p-tabView>
    </div>
</div>

<app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete($event)"></app-item-confirm>
